import { render, staticRenderFns } from "./TherapyInstrument.vue?vue&type=template&id=b1ce070c&scoped=true"
import script from "./TherapyInstrument.vue?vue&type=script&lang=ts"
export * from "./TherapyInstrument.vue?vue&type=script&lang=ts"
import style0 from "./TherapyInstrument.vue?vue&type=style&index=0&id=b1ce070c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ce070c",
  null
  
)

export default component.exports